import React from "react";
import { useState } from 'react';
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";



function Contact()
{
    const [isActive, setIsActive] = useState(false);
    function show_email()
    {
        setIsActive(true);
    }

    return (
        <div>
            <Helmet>
                <title>Contact | Lucas RODRIGUEZ</title>
                <meta name="description" content="Contact page of Lucas RODRIGUEZ" />
            </Helmet>
            <h2>Contact</h2>
            <p>
                Please use this email address. You can also contact me via <a href="https://linkedin.com/in/lcsrodriguez" target="_blank">LinkedIn</a>.
            </p>
            <p>
                <button id="show" className={"btn btn-dark"} onClick={() => show_email()}><i class="fa fa-envelope" style={{ 'margin-right': '5px' }}></i>Show email address</button>
            </p>
            {/* + (isActive ? "dark" : "secondary") */}
            {(isActive ?

                <p>
                    Email: <a id="mail" href={"mailto:" + (isActive ? "lcsrodriguez" + "@" + "pm.me" : "")}>{isActive ? "lcsrodriguez" + "@" + "pm.me" : ''}</a>
                </p>
                : <p>&nbsp;</p>)}
            {/* <p className="text-muted small">
                <NavLink to="/pgp">PGP key</NavLink>
            </p> */}
        </div >
    );
}

export default Contact; 